// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__3468o","withSideLogo":"styles_withSideLogo__3FBwm","title":"styles_title__3Ule4","logo":"styles_logo__3SN3G"};